import { render } from "./AddInput.vue?vue&type=template&id=20d15e58"
import script from "./AddInput.vue?vue&type=script&lang=js"
export * from "./AddInput.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__